<template>
    <!-- <div class="w-full mb-5">
        <h3 class="Label mb-4">How would you prefer to learn?</h3>

        <div class="flex flex-wrap justify-content-center gap-3">
            <div v-for="option in learningOptions" :key="option.value" class="pill-option cursor-pointer"
                :class="{ 'pill-option-selected': selectedLearningOptions.includes(option) }" role="button" tabindex="0"
                @click="toggleOption(selectedLearningOptions, option)"
                @keydown.enter.prevent="toggleOption(selectedLearningOptions, option)">
                <div class="flex align-items-center gap-2">
                    <i class="pi" :class="selectedLearningOptions.includes(option) ? 'pi-check' : 'pi-plus'" />
                    <span class="Paragraph-Regular">{{ option.label }}</span>
                </div>
            </div>
        </div>
    </div> -->

    <div class="w-full mb-5">
        <h3 class="Label mb-4">What is your preferred time for the classes?</h3>

        <div class="flex flex-wrap justify-content-center gap-3">
            <div v-for="option in timeOptions" :key="option.value" class="pill-option cursor-pointer"
                :class="{ 'pill-option-selected': selectedTimeOptions.includes(option) }" role="button" tabindex="0"
                @click="toggleOption(selectedTimeOptions, option)"
                @keydown.enter.prevent="toggleOption(selectedTimeOptions, option)">
                <div class="flex align-items-center gap-2">
                    <i class="pi" :class="selectedTimeOptions.includes(option) ? 'pi-check' : 'pi-plus'" />
                    <span class="Paragraph-Regular">{{ option.label }}</span>
                </div>
            </div>
        </div>
    </div>

    <div class="w-full mb-5">
        <h3 class="Label mb-4">What is your preferred medium for the classes?</h3>

        <div class="flex flex-wrap justify-content-center gap-3">
            <div v-for="option in mediumOptions" :key="option.value" class="pill-option cursor-pointer"
                :class="{ 'pill-option-selected': selectedMediumOptions &&selectedMediumOptions.value === option.value }" role="button"
                tabindex="0" @click="toggleOption(selectedMediumOptions, option, true)"
                @keydown.enter.prevent="toggleOption(selectedMediumOptions, option, true)">
                <div class="flex align-items-center gap-2">
                    <i class="pi" :class="selectedMediumOptions && selectedMediumOptions.value === option.value ? 'pi-check' : 'pi-plus'" />
                    <span class="Paragraph-Regular">{{ option.label }}</span>
                </div>
            </div>
        </div>
    </div>
    <Button label="Next" class="orange-button mt-6" @click="nextStep" />
</template>

<script setup>
import { ref, defineEmits } from "vue";
import { learningOptions, timeOptions, mediumOptions } from "@/utils/options";
import { Button } from "primevue";
import { notifyWarn } from "@/utils/notification";

const emit = defineEmits(["way-of-study-selected"]);

const selectedLearningOptions = ref([]);
const selectedTimeOptions = ref([]);
const selectedMediumOptions = ref(null);

const toggleOption = (list, optionValue, medium = false) => {
    if(medium){
        selectedMediumOptions.value = optionValue;
        return
    }
    const target = Array.isArray(list) ? list : list.value;
    const index = target.indexOf(optionValue);
    if (index > -1) {
        target.splice(index, 1);
    } else {
        target.push(optionValue);
    }
};

const nextStep = async () => {
    let hasErrors = false;
    await toggleOption(selectedLearningOptions, learningOptions[0]);
    if (selectedLearningOptions.value.length === 0) {
        notifyWarn("Please select your preffered learning method");
        hasErrors = true;
    }
    if (selectedTimeOptions.value.length === 0) {
        notifyWarn("Please select your preffered time");
        hasErrors = true;
    }
    if (!selectedMediumOptions.value) {
        notifyWarn("Please select your preffered medium");
        hasErrors = true;
    }
    if (hasErrors) {
        return
    }
    emit('way-of-study-selected', {
        learningMethods: selectedLearningOptions.value,
        preferredTime: selectedTimeOptions.value,
        preferredMedium: selectedMediumOptions.value
    })
}
</script>

<style scoped>
.Paragraph-Regular {
    color: var(--orange-500);
}

.pill-option {
    padding: 8px 16px;
    border: 2px solid var(--gray-300);
    border-radius: 50px;
    background: white;
    transition: all 0.3s ease;
    min-width: 120px;
    text-align: center;
    cursor: pointer;
    user-select: none;
    outline: none;
}

.pill-option:hover {
    border-color: var(--orange-500);
    transform: translateY(-2px);
    box-shadow: 0 5px 15px rgba(99, 102, 241, 0.15);
}

.pill-option-selected {
    border-color: var(--orange-500);
    background: var(--orange-500);
    color: white;
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(99, 102, 241, 0.25);
}

.pill-option-selected .Paragraph-Regular,
.pill-option-selected .pi {
    color: white;
}

.pill-option:not(.pill-option-selected) .pi {
    color: var(--orange-500);
}

/* Responsive design */
@media (max-width: 768px) {
    .pill-option {
        min-width: 140px;
        padding: 0.6rem 1.2rem;
    }
}
</style>
